/**
 * Apps/app wrapper for the shared TaskDialog that injects the local DealDialog component.
 * This preserves the ability to create new deals from within a task dialog in apps/app.
 */
import React from 'react'
import SharedTaskDialog from 'shared/components/dialogs/TaskDialog'
import type { TaskDialogProps } from 'shared/components/dialogs/TaskDialog'
import DealDialog from 'src/components/dialogs/DealDialog'

export type { TaskDialogProps }

export default function TaskDialog(props: TaskDialogProps) {
  return <SharedTaskDialog {...props} DealDialogComponent={DealDialog} />
}
